module.exports = "/_next/static/images/EmpowerMarketers@2x-49c66a1271519ab8f1907e0422dd1725.png";